import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {BLUE_DARKER, BLUE_LIGHTEST} from 'ui-library/Colors';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingDuotoneIcon from 'ui-library/icons/BenchlingDuotoneIcon';
import {assertNever} from 'util/Types';

export enum StudyDesignTabEditState {
  EDITING = 'EDITING',
  SAVING = 'SAVING',
  SAVED = 'SAVED',
}

export interface StudyDesignTabSavingButtonsProps {
  editState: StudyDesignTabEditState;
  isSaveDisabled: boolean;
  saveDisabledTooltip?: string;
  onCancel: () => void;
  onSave: () => void;
  onEdit: () => void;
}

export default function StudyDesignTabSavingButtons(props: StudyDesignTabSavingButtonsProps): JSX.Element {
  switch (props.editState) {
    case StudyDesignTabEditState.EDITING:
      return (
        <div>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            className={css(styles.button)}
            size={ButtonSize.MINI}
            text="Cancel"
            onClick={props.onCancel}
            disabled={false}
          />
          <Tooltip
            isDisabled={!props.isSaveDisabled || props.saveDisabledTooltip == null}
            text={props.saveDisabledTooltip}
          >
            <Button
              buttonStyle={ButtonStyle.PRIMARY}
              className={css(styles.button)}
              size={ButtonSize.MINI}
              text="Save"
              onClick={props.onSave}
              disabled={props.isSaveDisabled}
              dataTestAttrs={{
                component: 'StudyDesignTabSavingButtons',
                element: 'saveButton',
              }}
            />
          </Tooltip>
        </div>
      );
    case StudyDesignTabEditState.SAVING:
      return (
        <Button
          buttonStyle={ButtonStyle.PRIMARY}
          className={css(styles.button)}
          size={ButtonSize.MINI}
          text="Saving"
          onClick={props.onSave}
          disabled={true}
          icon={
            <div className={css(styles.spinnerIcon)}>
              <BenchlingDuotoneIcon
                icon="spinner-third"
                primaryColor={BLUE_DARKER}
                secondaryColor={BLUE_LIGHTEST}
                spin={true}
              />
            </div>
          }
        />
      );
    case StudyDesignTabEditState.SAVED:
      return (
        <Button
          icon="edit"
          buttonStyle={ButtonStyle.PRIMARY}
          className={css(styles.button)}
          size={ButtonSize.MINI}
          text="Edit"
          onClick={props.onEdit}
          disabled={false}
          dataTestAttrs={{
            component: 'StudyDesignTabSavingButtons',
            element: 'editButton',
          }}
        />
      );
    default:
      return assertNever(props.editState);
  }
}

export const styles = StyleSheet.create({
  button: {
    marginLeft: '6px',
  },
  spinnerIcon: {
    opacity: 0.5,
  },
});
